module.exports = __webpack_public_path__ + "static/media/delivery-service-process.6870fa50.svg";